import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-role',
  templateUrl: './role.component.html',
  styleUrls: ['./role.component.scss']
})
export class RoleComponent implements OnInit {
  displayedColumns: String[] = ['SR NO','Role','Action'];
  dataSource:any


  constructor() { }

  ngOnInit(): void {
  }

}
